import {
  Flex,
  HistoryBackButton,
  NotFoundIcon,
  ReloadScreenButton,
  Text,
  theme,
} from '@/components';
import { CONTENT_HEADER_HEIGHT, PAGE_HEADER_PADDING } from '@/utils';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';

type Props = {
  height?: string;
  message?: string;
  backRoute?: string;
  showBackButton?: boolean;
};

const innerPaddingY = PAGE_HEADER_PADDING * 2;
const contentHeight = `calc(100vh - ${CONTENT_HEADER_HEIGHT}px - ${innerPaddingY}px)`;

export const NotFound: FC<Props> = ({
  height,
  message,
  backRoute,
  showBackButton = true,
}) => {
  const { token } = theme.useToken();
  const { t } = useTranslation();
  return (
    <Flex
      style={{
        background: token.colorFillContent,
        height: height ?? contentHeight,
      }}
      align="center"
      justify="center"
      vertical
    >
      <NotFoundIcon />
      <div style={{ marginTop: 32 }}>
        <Text variant="h5" text={t('no-data')} />
      </div>
      {message && (
        <Text
          style={{ color: token.colorTextSecondary, marginTop: 16 }}
          text={message}
        />
      )}
      <Flex vertical align="center" style={{ marginTop: 20 }} gap={8}>
        {showBackButton && <HistoryBackButton backRoute={backRoute} />}
        <ReloadScreenButton />
      </Flex>
    </Flex>
  );
};
